import React, { useState } from 'react';
import logo from '../../assets/logo.webp';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import playstore from '../../assets/googleplay.webp';
import appstore from '../../assets/appstore.webp';

const Header = () => {
  const location = useLocation();
  return (
    <Navbar className='border-bottom' bg="white" variant="light" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/">
          <img className='logo'
            src={logo}
            alt="Truck-Repair-Shop"
             // Adjust size as needed
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='justify-content-between'>
          <Nav className="cust-nav align-items-center">
            <Nav.Link href="/" className={location.pathname === '/home' ? 'active' : ''}>Home</Nav.Link>
            <Nav.Link href="/plans" className={location.pathname === '/plans' ? 'active' : ''}>plans</Nav.Link>
            <Nav.Link href="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Nav.Link>
            <Nav.Link href="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Nav.Link>
            <Nav.Link href="/blogs" className={location.pathname === '/blogs' ? 'active' : ''}>Blog</Nav.Link>
          </Nav>

          <div className='header_phone'>
            <Nav className="cust-nav ml-0 align-items-center">
              <div className='header_phone_icon'>
                <i class="fas fa-phone-volume"></i>
              </div>

             <Nav.Link className='highlight_call' href="tel:+18008057820">
              <span>Call For More Details</span>
              +1 (800) 805-7820
             </Nav.Link>
            </Nav>

          </div>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
